

<div class="new-course-card">
    <div class="banner-img">
        <img width="378" height="174" [ngSrc]="course.logo_link.replace('https://s3-ap-south-1.amazonaws.com/iquantamedia', 'https://media.iquanta.in')" alt="{{course.course_name.split('.')[1]}}" loading="lazy">
    </div>
    <div class="course-content">
    <div class="course-highlights">
        <div class="tittle">
            <h3 *ngIf="course.course_name.includes('.')">
                {{course.course_name.split('.')[1]}}
            </h3>
            <h3 *ngIf="!course.course_name.includes('.')">{{course.course_name}}
            </h3>
            <p><span><i class="bi bi-star-fill"></i>4.95</span></p>
        </div>
        <div class="course-tag" >
            <ul *ngIf="getChipsData(course.features).length > 0">
                <li *ngFor="let features of getChipsData(course.features)">{{features}}</li>
                <!-- <li>IIM Calls Included</li> -->
            </ul>
        </div>
        </div>
        <div class="course-fatures" [ngClass]="{'course-features-big': getChipsData(course.features).length == 0}">
            <ul>
                <li> <p [innerHTML]="course.speciality | safeHtml"></p></li>
            </ul>
        </div>

        <div class="course-footer">
            <div class="price d-flex justify-content-between align-items-center">
                <div>
                 <h4> {{course.offer_price|currency}}</h4>
                 <h6><del>{{course.actual_price|currency}}</del></h6>
                </div>
                <div class="or">
                    or 
                </div>
                 <p class="f-light"> <b class="f-medium">₹{{getEmiAmount(course.offer_price)}}</b> /mo <span>for 6 months</span></p>
             </div>
             <div class="btns">
                 <ul>
                     <li class="d-flex"> 
                        <button type="button" class="btn btn-primary f-medium" (click)="enrollNow(course)">Enroll Now</button>
                        <button (click)="joinwhatsappEnquiry('https://api.whatsapp.com/send/?phone=918130900243')" class="wt-button"  matTooltip="Enquire Now"><i class="bi bi-whatsapp"></i></button>
                    </li>
                 </ul>
             </div>
        </div>
       
       
    </div>
</div>
